import React from "react";

const ArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.184"
    height="5.299"
    viewBox="0 0 9.184 5.299"
    {...props}
  >
    <path
      d="M.354.353,4.238,4.238.354,8.123"
      transform="translate(0.354 4.945) rotate(-90)"
      fill="none"
      stroke={props.color ?? "#000"}
      strokeLinecap="round"
      strokeWidth="1"
    />
  </svg>
);

export default ArrowIcon;
